export default "__VITE_ASSET__CjuXuURE__"